module.exports = __webpack_public_path__ + "fonts/visuelt-pro-light.87982248.ttf";